/*
   file contains functions that used from redux actions and perform operations for synchronise data with old components/stores
 */
import TaskStore from "../store/TaskStore"
import $ from "jquery"
import {WorkflowStatusType} from "../workflowStatus/constants"
import TaskManagementStore from "./TaskManagementStore"

export const afterChangeStatusFilterSelection = (filter) => {
    $(document).trigger('taskManagement_tasksTable_statusFilterChange', [filter])
}

export const afterBulkChangeTasksAssignmentsCb = (data) => {
    $(document).trigger("taskManagement_tasksAssignedTo", data);
}

export const afterBulkTasksMovedToCb = () => {
    $(document).trigger("taskManagement_tasksMovedTo");
}

const updateTaskInStore = (taskId, updatedData) => {
    let task = TaskStore.get(taskId);
    if (task) {
        task = {
            ...task,
            ...updatedData,
        }
        TaskStore.add(task);
    }
}

export const afterUpdateTaskStatusAndPositionCb = (taskId, projectId, workflowStatus) => {
    const completed = workflowStatus.type === WorkflowStatusType.COMPLETED

    updateTaskInStore(taskId, {
        workflowStatusId : workflowStatus.id,
        completed,
        projectId,
    })

    const result = {
        taskIds: [taskId],
        workflowStatusId: workflowStatus.id,
        isCompleted: completed
    }

    $(document).trigger("taskManagement_tasksStatusChange", result);
}

export const addTasks = (tasks) => {
    TaskStore.mergeAll(tasks)
}

export const removeTasks = (taskIds) => {
    TaskStore.removeMany(taskIds)
    TaskManagementStore.removeTasks(taskIds);
    $(document).trigger("taskManagement_removeTasks", [taskIds])
}

export const setEditableProjectIds = (editableProjectIds) => {
    TaskManagementStore.setEditableProjectIds(editableProjectIds)
}

export const setEditableCustomerIds = (editableCustomerIds) => {
    TaskManagementStore.setEditableCustomerIds(editableCustomerIds)
}

export const importTasksSuccessEvent = "taskManagement_import_tasks_success"
export const afterImportTasksSuccess = () => {
    $(document).trigger(importTasksSuccessEvent)
}

export const exportErrorEvent = "taskManagement_export_error"

export const afterTaskListExportRequestFailed = (err) => {
    $(document).trigger(exportErrorEvent, [err])
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/syncCallbacks.js